var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.SuggestableTagView = function (superClass) {
  extend(SuggestableTagView, superClass);
  function SuggestableTagView() {
    return SuggestableTagView.__super__.constructor.apply(this, arguments);
  }
  SuggestableTagView.prototype.tagName = 'li';
  SuggestableTagView.prototype.className = 'bg-white';
  SuggestableTagView.prototype.template = 'work_tags/templates/suggestable_tag';
  SuggestableTagView.prototype.events = {
    "click .close": "removeModel"
  };
  SuggestableTagView.prototype.attributes = function () {
    return {
      'data-tag-id': this.model.id,
      'data-last-dragged': !!this.model.get('last_dragged')
    };
  };
  SuggestableTagView.prototype.initialize = function () {
    return this.listenTo(this.model, 'change', this.render);
  };
  SuggestableTagView.prototype.render = function () {
    this.$el.html(JST[this.template]({
      model: this.model.toJSON()
    }));
    return this;
  };
  SuggestableTagView.prototype.removeModel = function () {
    return this.model.collection.remove(this.model);
  };
  return SuggestableTagView;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;